<script lang="ts">
  import {DraftService, ThumbDraftService, VideoService} from '@/services';

  import Dialog from '../../../components/dialog/Dialog.svelte';
  import {onDestroy} from 'svelte';
  import {formatDateTime} from '@/utils/common';
  import {restoreDraft} from '@/components/drafts/draft-utils';
  import {restoreImageDraft} from '@/components/thumbnail/draft-utils';
  import {selVideo} from '@/pages/thumbPreview/viddialog-store';
  import {project, thumbnail} from '@/store';

  export let isDraftsDialogOpen = false;

  let isLoading = false;
  let drafts: Array<any> = [];

  const videoService = new VideoService();
  const draftService = new DraftService();
  const thumbnailService = new ThumbDraftService();

  async function checkForUnsavedDrafts() {
    isLoading = true;

    try {
      drafts = await draftService.getRecentDrafts();
    } catch (error) {
      console.log(error);
    }

    isLoading = false;
  }

  async function preRestoreDraft(draft: any) {
    const video = draft.video;

    const fullVideo = await videoService.getVideo(video.id, true);
    selVideo.set(fullVideo);

    if (draft.renderedVideos) {
      await draftService.getDraft(draft.id).then(response => {
        project.setVideo(fullVideo);
        restoreDraft(response.data, fullVideo);
      });
    } else {
      await thumbnailService.getDraft(draft.id).then(response => {
        thumbnail.setVideo(fullVideo);
        restoreImageDraft(response.data);
      });
    }
  }

  $: if (isDraftsDialogOpen === true) checkForUnsavedDrafts();

  onDestroy(() => {});
</script>

<Dialog bind:isDialogOpen={isDraftsDialogOpen} autoDismissDialog={true}>
  <div class="pointer-events-none flex h-full w-full justify-end">
    <div
      class="animateVideo pointer-events-auto h-full max-w-[420px] overflow-auto rounded-bl-2xl rounded-tl-2xl border-l border-zinc-400 bg-white shadow-lg dark:border-zinc-600 dark:bg-zinc-700"
    >
      <div class="flex w-full items-center gap-4 px-4 pt-4">
        <button on:click={() => (isDraftsDialogOpen = false)} class="flex items-center gap-1">
          <i class="fa-solid fa-x"></i>
        </button>
        <h1 class="text-xl font-bold">Most Recent Drafts</h1>
      </div>
      <div class="grid gap-2 p-2">
        {#if isLoading}
          {#each Array(parseInt((Math.random() * 5 + 2).toFixed(0))) as _, i}
            <div class="flex h-full max-h-[8rem] w-full gap-2 overflow-hidden rounded-lg p-2" style="max-height: 5rem;">
              <div
                class="h-full w-full animate-pulse rounded-lg bg-zinc-300 object-cover"
                style="max-width: 8rem; animation-delay: {400 * i}ms"
              />
              <div class="grid w-[calc(100%-8rem)] gap-1 text-start">
                <h1
                  class="animate-pulse truncate rounded-lg bg-zinc-300 text-lg font-bold"
                  style="width: {`${parseInt((Math.random() * 80 + 20).toFixed(0))}%`}; animation-delay: {600 * i}ms"
                >
                  &nbsp;
                </h1>
                <h1
                  class="animate-pulse rounded-lg bg-zinc-300 text-xs"
                  style="width: {`${parseInt((Math.random() * 30 + 20).toFixed(0))}%`}; animation-delay: {800 * i}ms"
                >
                  &nbsp;
                </h1>
              </div>
            </div>
          {/each}
        {:else}
          {#each drafts as draft}
            <button
              on:click={() => preRestoreDraft(draft)}
              class="flex h-full max-h-[8rem] w-full gap-2 overflow-hidden rounded-lg p-2 hover:bg-zinc-200"
              style="max-height: 5rem;"
            >
              <img
                class="h-full w-full rounded-lg object-cover"
                style="max-width: 8rem;"
                alt="draft-thumbnail"
                src={(draft.project?.video?.preview
                  ? draft.project?.video?.preview
                  : draft.video?.preview?.publicUrl) || ''}
              />
              <div class="w-[calc(100%-8rem)] text-start">
                <h1 class="truncate text-lg font-bold">{draft.video?.name || 'Untitled'}</h1>
                <span class="text-xs">{formatDateTime(draft.updatedAt)}</span>
              </div>
            </button>
          {/each}
        {/if}
      </div>
    </div>
  </div>
</Dialog>

<style>
  .animateVideo {
    min-width: 280px;
    animation: animateVideoSidebar 0.3s ease-in-out forwards;
  }

  @keyframes animateVideoSidebar {
    0% {
      width: 0%;
      opacity: 0;
    }
    100% {
      width: 100%;
      opacity: 1;
    }
  }
</style>
